import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudentportalRoutingModule } from './studentportal-routing.module';
import { StudenthomeworkComponent } from './studenthomework/studenthomework.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, CollapseModule, TabsModule, PopoverModule, TooltipModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { StudentFeeDetailComponent } from './student-fee-detail/student-fee-detail.component';
import { StudentAttendanceDetailsComponent } from './student-attendance-details/student-attendance-details.component';
import { StudentTerminalReportComponent } from './student-terminal-report/student-terminal-report.component';
import { StudentFeePaymentComponent } from './student-fee-payment/student-fee-payment.component';
import { StudentAcademicsComponent } from './student-academics/student-academics.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { StudentFeeChallanComponent } from './student-fee-challan/student-fee-challan.component';

@NgModule({
  declarations: [StudenthomeworkComponent, StudentProfileComponent, StudentFeeDetailComponent, StudentAttendanceDetailsComponent, StudentTerminalReportComponent,StudentFeePaymentComponent, StudentAcademicsComponent, PaymentSuccessComponent, StudentFeeChallanComponent],
  imports: [
    CommonModule,
    StudentportalRoutingModule,
    AdminModule ,    
    FormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot()

  ]
})
export class StudentportalModule { }
